<template>
  <div class="bg-indigo-500 px-16">
    <ul class="tabbed-menu horizontal theme--brand">
      <li class="tabbed-menu__item">
        <RouterLink :to="{ name: 'admin.facebookCampaigns.show' }" class="tabbed-menu__link" exact>
          {{ $t('general') | capitalize }}
        </RouterLink>
      </li>
      <li class="tabbed-menu__item">
        <RouterLink
          :to="{ name: 'admin.facebookCampaigns.adsets' }"
          class="tabbed-menu__link"
          exact
        >
          {{ $t('adsets') | capitalize }}
        </RouterLink>
      </li>
      <li class="tabbed-menu__item">
        <RouterLink :to="{ name: 'admin.facebookCampaigns.ads' }" class="tabbed-menu__link" exact>
          {{ $t('ads') | capitalize }}
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TabbedMenu',
};
</script>
